// Reasons offered when marking an item damaged. The API accepts any short text,
// so this list can change without a migration.
export const DAMAGE_REASONS = [
  'Stain',
  'Torn / hole',
  'Manufacturing defect',
  'Missing tag / label',
  'Other',
];

// Sending damages to the warehouse is manager-level: admin (1), manager (2) or is_admin,
// matching the backend check in api/damages.py.
export const canSendDamages = (user) => Boolean(user && (user.id === 1 || user.id === 2 || user.is_admin));
